import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useUser } from "@dreamchimney/user-context";

import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Pagination from "react-bootstrap/Pagination";
import { LinkContainer } from "react-router-bootstrap";

import SleeveContainer from "~/Components/Containers/SleeveContainer";
import Tags from "~/Components/Tags";
import ChimneyName from "~/Components/ChimneyName";
import "./sleeve.less";
import SleeveCommentsContainer from "~/Components/Containers/SleeveCommentsContainer";
import FavoriteIcon from "~/Components/Global/FavoriteIcon";
import CommentIcon from "~/Components/Global/CommentIcon";
import ShareIcon from "~/Components/Global/ShareIcon";

//

const DetailPage = ({ match }) => {
  const [sleeveId, setSleeveId] = useState(match.params.id);
  const { state: userState, dispatch } = useUser();

  // console.log("🚀 ~ file: DetailPage.js ~ line 23 ~ DetailPage ~ userState", userState);

  return (
    <div className="page-sleeve">
      <Helmet>
        <title>Sleevery | Sleeve #{sleeveId} | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <h1 className="page-header">Sleeve #{sleeveId}</h1>
        </Col>
        <Col xs={12}>
          <SleeveContainer
            id={sleeveId}
            render={({ sleeve, next, previous }) => {
              const sleeveOwner = userState.user.dir === sleeve.chim_dir;
              return (
                <div>
                  <div className="sleeve-next-prev">
                    <Pagination>
                      <LinkContainer to={`/sleeves/view/${previous}`}>
                        <Pagination.Item key={previous}>Previous</Pagination.Item>
                      </LinkContainer>
                      <LinkContainer to={`/sleeves/view/${next}`}>
                        <Pagination.Item key={next} disabled={next === 0}>
                          Next
                        </Pagination.Item>
                      </LinkContainer>
                    </Pagination>
                  </div>
                  <img
                    src={`https://res.cloudinary.com/dreamchimney/image/upload/w_450/sleevery/${sleeve.id}.jpg`}
                    className="sleeve-main center-block img-responsive"
                  />

                  <div className="album-details">
                    <Row>
                      <Col xs={12} md={9}>
                        <h2>
                          {sleeve.artist} "{sleeve.title}"
                        </h2>
                      </Col>
                      <Col xs={12} md={3}>
                        <span className="sleeve-action-icons">
                          <FavoriteIcon sleeveId={sleeve.id} className="page-sleeve-favorite" />
                          <CommentIcon />
                          <ShareIcon sleeve={sleeve} />
                        </span>
                      </Col>
                    </Row>

                    <div className="album-tags">
                      <i className="fa fa-tags"></i>
                      <Tags tags={sleeve.tags} />
                    </div>

                    <div className="album-added">
                      Added {sleeve.created} by{` `}
                      <ChimneyName sleeve={sleeve} />
                    </div>

                    {sleeveOwner && (
                      <div className="you-can-edit">
                        <Link to={`/sleeve/edit/${sleeve.id}`}>
                          <i className="fa fa-edit"></i>
                          You can edit this
                        </Link>
                      </div>
                    )}
                  </div>
                  {/* <div>
                    <h4>Share</h4>
                  </div> */}
                  <div className="comments-list" id="comments"></div>
                  <SleeveCommentsContainer sleeveId={sleeve.id} />
                </div>
              );
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DetailPage;
